import React from 'react';
import { styled } from '@mui/styles';
import { Skeleton } from '@mui/material';

export const MatchCompaniesStyled = styled('div')(({ theme: { palette, spacing } }: any) => ({
    width: '100%',
    '& .step-visualization': {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        gap: '25px',
        marginBottom: spacing(2),
        '& .description': {
            color: palette.colors.greyDark,
            fontSize: '20px',
        },
        '& .arrow': {
            fontSize: '63px',
            maxHeight: '20px',
        },
        '& .logo': {
            fontSize: '16px',
            display: 'flex',
            gap: '5px',
            lineHeight: '16px',
            '& .icon': {
                color: palette.colors.black,
                fontSize: '15px',
                '& path': {
                    '&:nth-child(1)': { fill: palette.colors.red },
                    '&:nth-child(2)': { fill: palette.colors.red },
                    '&:nth-child(3)': { fill: palette.colors.bluePale },
                    '&:nth-child(4)': { fill: palette.colors.bluePale },
                },
            },
        },
    },
    '& .companies-container': {
        display: 'flex',
        flexDirection: 'column',
    },
}));

export const SkeletonContainerStyled = styled('div')(({ theme: Theme }) => ({
    width: '100%',
    padding: '8px 40px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: '15px',
}));

export const SkeletonStyled = styled(({ ...props }) => <Skeleton {...props} variant="rectangular" animation="wave" />)(
    ({ theme: Theme }) => ({
        borderRadius: '8px',
    })
);
